/*
 * @Author: LiZhiWei
 * @Date: 2026-01-15 11:01:33
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-28 14:41:31
 * @Description:
 */
export const useConsultation = () => {
  const isConsultationOpen = useState('isConsultationOpen', () => false)

  const openConsultation = () => {
    isConsultationOpen.value = true
  }

  const closeConsultation = () => {
    isConsultationOpen.value = false
  }

  const toggleConsultation = () => {
    isConsultationOpen.value = !isConsultationOpen.value
  }

  return {
    isConsultationOpen,
    openConsultation,
    closeConsultation,
    toggleConsultation,
  }
}
